import { Component, EventListener, GondelBaseComponent } from '@gondel/core';
import { SearchInputEvents } from '../../../molecules/search-input/js/search-input';

/**
 * search-input module implementation.
 * @author Danijel Malinovic <danijel.malinovic@merkleinc.com>
 */

enum Selectors {
	SearchButton = '.js-career-search__search-button .a-button',
	InputField = '.js-m-search-input__input',
}

/**
 * All custom attributes inside the current _ctx object
 */
enum CustomAttributes {
	CareerPage = 'data-career-page-url',
}

@Component('CareerSearch')
export class CareerSearch extends GondelBaseComponent {
	private _baseUrl!: string;

	public start() {
		this._baseUrl = this._ctx.getAttribute(CustomAttributes.CareerPage) ?? '';
	}

	/**
	 * This functions listens on the search button click inside the search-input molecule
	 * @param event
	 */
	@EventListener(SearchInputEvents.OnSearchClick)
	public _onSearchClick(event: object): void {
		window.open(this._concatenateUrl(event), '_blank');
	}

	/**
	 * This functions listens on the key press inside the search-input molecule
	 * @param event
	 */
	@EventListener(SearchInputEvents.OnKeyPress)
	private _onKeyPress(event: object): void {
		const searchRoleButton = this._ctx.querySelector(Selectors.SearchButton);
		searchRoleButton?.setAttribute('href', this._concatenateUrl(event));
	}

	// Concats the defined url with the searchtext
	private _concatenateUrl(event): string {
		return this._baseUrl.concat('?q=', event.data.eventData.inputText);
	}
}
